import React from 'react'
import { Route } from 'react-router-dom'
import { LayoutTradeshow } from './tradeshow/layout-tradeshow'
import { LayoutGroup } from './group/layout-group'
import { LayoutUserLogin } from './user-login/layout-user-login'
import { LayoutLoginProvider } from './login-provider/layout-login-provider'
import { LayoutSso } from './sso/layout-sso'
import { LayoutOrganization } from './organization/layout-organization'
import { LayoutOrgEmailActivity } from './email-activity/layout-email-activity'
import { LayoutLoginSetting } from './login-settings/layout-login-setting'
import { LayoutPasswordUpdate } from './password-update/layout-password-update'
import { LayoutDeleteAccount } from './delete-account/layout-delete-account'
import { LayoutAnalytic } from './analytic/layout-analytic'
import { LayoutDashboard } from './dashboard/layout-dashboard'
import { LayoutContent } from './node/layout-content'
import { FeatureTradeShow } from '../../../shared/component/org-feature'
import { LayoutLoginSession } from './login-session/layout-login-setting'
import { LayoutSelfRegister } from './self-register/layout-self-register'
import { LayoutLms } from '../../../view/lms-admin/layout-lms'
import { LayoutOrgAuditLog } from './audit-log/route-audit-log'
import { LayoutApiKeys } from './api-keys/layout-api-keys'
import { LayoutNotifications } from './notifications/layout-notifications'

export const LayoutOrg = () => {
  return (
    <React.Fragment>
      <LayoutUserLogin />
      <LayoutGroup />
      <LayoutLoginProvider />
      <LayoutSso />
      <LayoutOrganization />
      <LayoutOrgEmailActivity />
      <LayoutLoginSetting />
      <LayoutLoginSession />
      <LayoutPasswordUpdate />
      <LayoutDeleteAccount />
      <LayoutAnalytic />
      <LayoutDashboard />
      <LayoutOrgAuditLog />
      <LayoutApiKeys />
      <LayoutNotifications />

      <LayoutContent />

      <LayoutLms />

      <FeatureTradeShow>
        <Route path="/org/tradeshow" component={LayoutTradeshow} />
        <Route path="/org/self-register" component={LayoutSelfRegister} />
      </FeatureTradeShow>
    </React.Fragment>
  )
}
